<template>
  <div v-if="CONFIG.mode !== 'embedded'">
    <div>
      <nav class="navbar navbar-expand-lg rounded" type="light" variant="light">
        <!--
        <b-navbar-brand href="#"><img class="logo" width="100" alt="Vue logo" src="../assets/logo.png" /><b>IREAL</b></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <ul class="navbar-nav">
            <b-nav-item><router-link to="/" class="nav-item">{{ $t('home') }}</router-link></b-nav-item>
            <b-nav-item>|</b-nav-item>
            <b-nav-item><router-link to="/propos" class="nav-item">{{ $t('tutorial') }}</router-link></b-nav-item>
            <b-nav-item>|</b-nav-item>
            <b-nav-item><router-link to="/contact" class="nav-item">{{ $t('contact') }}</router-link></b-nav-item>
          </ul>



          Right aligned nav items -->
        <div class="nav justify-content-end">
          <div class="nav-item" href="#">
            <select class="form-control" v-model="$i18n.locale">
              <option
                v-for="locale in locales"
                :key="locale.if"
                v-bind:value="locale.id"
                >{{ locale.name }}
              </option>
            </select>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  name: "basehead",
  data() {
    return {
      locales: [
        { id: "en", name: "English", icon: "../assets/english.png" },
        { id: "fr", name: "Français", icon: "../assets/france.png" }
      ],
      currentLocale: "en"
    };
  },
  watch: {
    // va changer la langue dans le store. cette langue sera la clé pour le champ "local" du model experience.
    currentLocale: function(value) {
      this.$store.commit("language", value);
    }
  }
};
</script>
<style scoped>
.logo {
  margin-right: 15px;
}
</style>
